import { Box } from "@mui/material";

interface Props {
  icon: React.ReactElement;
  title: string;
  content: string;
}

const CryptoOfferingCard: React.FC<Props> = ({ icon, title, content }) => {
  return (
    <Box
      sx={{
        minHeight: 150,
        borderTop: "1px solid #1684FF",
        padding: "0 1.5rem",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          paddingTop: "1.5rem",
          paddingBottom: "1rem",
          color: "#1684FF",
        }}
      >
        <Box sx={{ marginRight: "1.25rem" }}>{icon}</Box>
        <Box sx={{ fontSize: 25, lineHeight: 1.2, fontWeight: 600 }}>
          {title}
        </Box>
      </Box>
      <Box sx={{ fontSize: 18, lineHeight: 1.2 }}>{content}</Box>
    </Box>
  );
};

export default CryptoOfferingCard;
